<template>
  <div class="modal fade" id="forgotPasswordModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Forgot Password</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h6 class="mb-4">
            A code will be sent to your email address. That code will be
            required for you to reset your password.
          </h6>
          <h6 v-if="errorMessage != ''" class="text-danger">
            {{ errorMessage }}
          </h6>
          <form @submit.prevent="sendCode">
            <div class="form-group">
              <label for="email">Email Address</label>
              <input
                type="email"
                class="form-control"
                id="email"
                placeholder="john.doe@example.com"
                v-model="emailAddress"
                required
              />
            </div>
            <div class="mt-4">
              <button
                type="button"
                class="btn btn-outline-secondary"
                v-on:click="cancel()"
              >
                Cancel
              </button>
              <button type="submit" class="btn btn-outline-primary float-right">
                Send Code
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import $ from "jquery";

export default {
  name: "ForgotPasswordModal",
  data() {
    return {
      emailAddress: "",
      errorMessage: ""
    };
  },
  methods: {
    sendCode() {
      this.$store.commit("updateLoading", true);
      this.errorMessage = "";
      Auth.forgotPassword(this.$data.emailAddress)
        .then(() => {
          $("#forgotPasswordModal").modal("hide");
          this.$store.commit("updateLoading", false);
          this.$router.push("resetpassword?email=" + this.$data.emailAddress);
        })
        .catch(err => {
          console.log(err);
          if (err.code == "UserNotFoundException") {
            this.errorMessage =
              "The email address you entered is not in our system. Please verify your email address and try again.";
          }
          this.$store.commit("updateLoading", false);
        });
    },
    cancel() {
      $("#forgotPasswordModal").modal("hide");
      this.emailAddress = "";
      this.errorMessage = "";
    }
  }
};
</script>
